export default {
  de: {
    loading: 'Lädt...',
    search: 'Suche',
    noSearchResults: 'Es wurden keine Suchvorschläge gefunden.'
  },
  en: {
    loading: 'Loading...',
    search: 'Search',
    noSearchResults: 'No search results found.'
  }
}
